import React from "react";
import { useSelector } from "react-redux";
import PieChart from "../../../../components/pieChart/pieChart";

const ClosingPieChart = () => {
  const closingBreakdown = useSelector(
    (state) => state.firstRiders.firstTimeRiders.closingBreakdown
  );
  return closingBreakdown?.length !== 0 ? (
    <PieChart data={closingBreakdown} clickablePie showLegend legendPosition="right" />
  ) : (
    <p style={noDataStyles}>No data found for this time period.</p>
  );
};

const noDataStyles = {
  textAlign: "center",
  color: "#8791a0",
  fontSize: "1.5em",
  fontWeight: 300,
  paddingTop: "75px"
};

export default ClosingPieChart;
